import OrganisationRequestModelBase from '../_generated/modelBases/organisation-request-model-base';

export default class OrganisationRequestModel extends OrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
